import styled from "styled-components";

export const AboutIntroContainer = styled.div`
   font-family: 'Outfit', sans-serif;
    .aboutintro_main {
        padding: 100px 0;
        padding-bottom: 0px;
    }
    h4.about-intro_subtxt {
        color: #021E40;
        font-weight:600;
    }
    
    .about_intro_content{
        display: flex;
        gap: 20px;
        width: 100%;
    }
    .about_intro_content strong {
        color: #021E40;
    }
    .video_section_founder .mygrid-row {
        border-top: 1px solid #A1A0A0;
        padding: 70px 0;
        padding-bottom: 0;
        align-items: center;
    }

    .plans_intro_content_right_heading{
        color: #EE2D2F;
        font-weight:500;
        font-size: 29px;
        margin-bottom: 10px;
    }
    .plans_intro_content_right_description strong{
        font-weight: 700;
        color:#021E40
        font-size: 18px;
    }

    .plans_intro_content_left {
        width: 40%;
    }

    .plans_intro_content_right {
        width: 60%;
    }

    @media (max-width: 991px) {
        .aboutintro_main{
            padding-top:70px;
            padding-bottom:0px;
        }
         
        .about_intro_content {
			flex-wrap: wrap;
            margin-bottom: 0px;
		}
        .plans_intro_content_left, .plans_intro_content_right {
			width: 100%;
		}
        .plans_intro_content_right_heading {
                font-size: 24px !important;
            }
    }
    @media (max-width: 767px) {
        .aboutintro_main {
            padding: 50px 0;
            padding-bottom: 0px;
        }
        .about_intro_content {
			flex-wrap: wrap;
			margin-bottom: 55px;
		}
            
    }
`;
